import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useStartDictate(): () => void {
  return useWebChatAPIContext().startDictate;
}
